import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../ds/tokens/fonts.css';
import '../ds/tokens/tokens.css';
import '../ds/styles/components.css';
import '../guia-home.css';
import Brujula from '../ds/components/Brujula';
import Button from '../ds/components/Button';
import BrujulaGuia from './BrujulaGuia';
import CatalogoAgencia from './CatalogoAgencia';
import ChatContacto from './ChatContacto';
import { AGENDADOR } from '../data/ofertas';
import { evento, iniciarMedicion } from '../lib/medicion';

// /catalogo: las tareas de la agencia como página propia, para linkearla desde todos lados (An, 05/11: «el catálogo
// tiene que linkearse de todos lados, si es la demostración del producto. concentrate en convertir»). Cierra con las
// dos salidas de la oferta: postularse o agendar la llamada de 20 minutos. El link con #<tarea> abre esa ficha.
const CatalogoPagina = () => {
  const [chat, setChat] = useState({ abierto: false, texto: '', contexto: null });
  const abrirChat = (texto, contexto = null) => setChat({ abierto: true, texto, contexto });
  const inicial = typeof window !== 'undefined' ? window.location.hash.slice(1) : '';

  useEffect(() => iniciarMedicion(), []);
  useEffect(() => { evento('paso_visto', { pantalla: 'catalogo' }); }, []);

  // 🟠 Textos del cierre, míos, a validar por An.
  const postularse = () => {
    evento('contacto_abierto', { pantalla: 'catalogo' });
    abrirChat('Quiero postularme a Agencia.', { asunto: 'Postulación a Agencia', servicio: 'Agencia', respuestas: { producto: 'ia' }, preguntas: ['ia_equipo', 'ia_tarea'] });
  };

  return (
    <div className="gh-root gh-catalogo-pagina" data-theme="claro">
      <header className="gh-header">
        <Link to="/" className="gh-logo" data-activo="true" aria-label="GUIA: volver al inicio"><Brujula sobreClaro /></Link>
        <div className="gh-header__lado">
          <span className="gh-pildora"><Link to="/" className="gh-link">← Productos</Link></span>
        </div>
      </header>

      <main className="gh-cierre">
        <section className="gh-banda gh-banda--catalogo" aria-labelledby="gh-c-catalogo">
          <div className="gh-banda__in">
            <div className="gh-guia"><BrujulaGuia /><h1 id="gh-c-catalogo" className="gh-cierre__titulo">Las tareas de tu agencia</h1></div>
            <p className="gh-catalogo__bajada">Un agente por área. Tocá una tarea y mirá cómo la hace.</p>
            <CatalogoAgencia abrirChat={abrirChat} datos={{ producto: 'ia' }} inicial={inicial} />
          </div>
        </section>
        <section className="gh-banda gh-banda--medi" aria-labelledby="gh-c-armala">
          <div className="gh-banda__in gh-catalogo__cierre">
            <h2 id="gh-c-armala" className="gh-cierre__titulo">Armá tu agencia.</h2>
            <p className="gh-catalogo__bajada">Empezá con una tarea y sumá otras cuando quieras.</p>
            <div className="gh-acciones gh-salidas">
              <Button variant="solido" onClick={postularse}>Quiero postularme</Button>
              <a className="gh-salidas__llamada" href={AGENDADOR} target="_blank" rel="noopener noreferrer" onClick={() => evento('escribime_tocado', { pantalla: 'catalogo', opcion: 'agendar' })}>¿Tenés dudas? Agendá una llamada de 20 minutos</a>
            </div>
          </div>
        </section>
      </main>

      <ChatContacto abierto={chat.abierto} setAbierto={a => setChat(c => ({ ...c, abierto: typeof a === 'function' ? a(c.abierto) : a }))} texto={chat.texto} contexto={chat.contexto} />

      <footer className="gh-pie">
        <span>Córdoba, Argentina</span>
        <Link to="/privacidad">Privacidad</Link>
      </footer>
    </div>
  );
};

export default CatalogoPagina;
